import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
// import axios from "axios";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Table,
  UncontrolledTooltip,
  Spinner,
  Pagination,
  PaginationItem,
  PaginationLink,
  FormGroup,
  Modal,
} from "reactstrap";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

// actions
import { resetProfiles, getProfiles, deleteProfile } from "../../store/profiles/actions";

import { useDispatch, useSelector } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { renderPagination } from "../../Libs/CrudUtils/crudUtils";

const Profiles = ({ t }) => {
  const dispatch = useDispatch();
  const qtdDefault = 7;

  const {
    dataProfile,
    loadingProfile,
    loadingDeleteProfile,
    errorProfile,
    successDeleteProfile,
    idProfileDelete,
  } = useSelector((state) => state.Profile);

  const [page, setPage] = useState(1);
  const [profileId, setProfileId] = useState("");
  const [profileName, setProfileName] = useState("");

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const [nameF, setNameF] = useState("");
  const [descriptionF, setDescriptionF] = useState("");

  const [modal, setModal] = useState(false);

  const handleFilter = () => {
    setPage(1);
    dispatch(getProfiles(1, qtdDefault, name, description));
  };

  const handlePage = (value) => {
    setPage(value);
    dispatch(getProfiles(value, qtdDefault, name, description));
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataProfile && dataProfile.paging) {
      if (page < dataProfile.paging.length) {
        handlePage(page + 1);
      }
    }
  };

  const toggleModal = useCallback(() => {
    setModal(!modal);
  }, [modal]);

  const handleDelete = () => {
    if (profileId) {
      dispatch(deleteProfile(profileId));
    }
  };

  const showToast = (type, message) => {
    toastr[type](message);
  };

  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
  };

  useEffect(() => {
    if (errorProfile) {
      showToast(
        "error",
        errorProfile[0].value === "not found"
          ? t("Profile not found")
          : errorProfile === "Your session has expired"
          ? t("Your session has expired")
          : errorProfile ===
            "Sorry! the page you are looking for could not be found"
          ? t("Sorry! the page you are looking for could not be found")
          : errorProfile ===
              "Sorry! something went wrong, please contact our support team" &&
            t("Sorry! something went wrong, please contact our support team")
      );
      dispatch(resetProfiles());
    } else if (errorProfile && idProfileDelete) {
      showToast("error", t("Delete error"));
      toggleModal();
      dispatch(resetProfiles());
      dispatch(getProfiles());
    }
  }, [dispatch, toggleModal, idProfileDelete, errorProfile, dataProfile, t]);

  useEffect(() => {
    if (successDeleteProfile) {
      showToast("success", t("Profile deleted"));
      toggleModal();
      dispatch(resetProfiles());
      dispatch(getProfiles());
    }
  }, [dispatch, toggleModal, successDeleteProfile, t]);

  useEffect(() => {
    handleFilter();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/profiles"
            title={t("Dashboard")}
            breadcrumbItem={t("Profiles")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody className="card-height">
                  <AvForm onValidSubmit={handleFilter}>
                    <Row>
                      <Col xs="12" md="4" lg="3" xl="auto" className="mb-3 ">
                        <FormGroup>
                          <AvField
                            onChange={(e) => setNameF(e.target.value)}
                            label={t("Name")}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Name") + "..."}
                            value={name}
                            validate={{
                              minLength: {
                                value: 3,
                                errorMessage: t("Invalid field"),
                              },
                              maxLength: {
                                value: 45,
                                errorMessage: t("Invalid field"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12" md="4" lg="3" xl="auto" className="mb-3 ">
                        <FormGroup>
                          <AvField
                            onChange={(e) => setDescriptionF(e.target.value)}
                            label={t("Description")}
                            id="description"
                            name="description"
                            type="text"
                            className="form-control"
                            placeholder={t("Description") + "..."}
                            value={description}
                            validate={{
                              minLength: {
                                value: 3,
                                errorMessage: t("Invalid field"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Invalid field"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col
                        xs="12"
                        md="4"
                        lg="auto"
                        style={{ marginTop: "1.7rem" }}
                      >
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light w-100 mb-3 mr-3"
                          onClick={() => {
                            setName(nameF);
                            setDescription(descriptionF);
                          }}
                        >
                          <i className="mdi mdi-feature-search-outline mr-1"></i>
                          {t("Search")}
                        </Button>
                      </Col>
                      <Col
                        xs="12"
                        md="12"
                        lg="auto"
                        className="ml-auto"
                        style={{ marginTop: "1.7rem" }}
                      >
                        <div className="text-sm-right mb-3" id="new-profile">
                          <Link to="/profile">
                            <Button
                              type="button"
                              color="success"
                              className={"waves-effect waves-light w-100 mr-2 "}
                            >
                              <i className="mdi mdi-plus mr-1"></i>
                              {t("Add Profile")}
                            </Button>
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>

                  <div className="table-responsive">
                    <PerfectScrollbar>
                      <Table className="table table-centered table-nowrap">
                        <thead className="thead-light">
                          <tr>
                            <th>
                              <span className="ml-2">{"#"}</span>
                            </th>
                            <th>{t("Name")}</th>
                            <th>{t("Permission type")}</th>
                            <th>{t("Description")}</th>
                            <th>{t("Nº of users")}</th>
                            <th>{t("Action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {!loadingProfile && !dataProfile && (
                            <tr>
                              <td colSpan="8" align="center">
                                {t("Click search to show the records")}
                              </td>
                            </tr>
                          )}
                          {loadingProfile ? (
                            <tr>
                              <td colSpan="8" align="center">
                                <Spinner
                                  animation="border"
                                  size="sm"
                                  className="spinner"
                                />
                              </td>
                            </tr>
                          ) : dataProfile &&
                            dataProfile.profiles &&
                            dataProfile.profiles.length > 0 ? (
                            dataProfile.profiles.map((profile, key) => (
                              <tr key={key}>
                                <td className="pl-4">{key + 1}</td>
                                <td className="column-text-overflow-10">
                                  {profile.name}
                                </td>
                                <td className="column-text-overflow-10">
                                  {profile.role_id}
                                </td>
                                <td className="column-text-overflow-10">
                                  {profile.description}
                                </td>
                                <td>{profile.count}</td>
                                <td className="pl-0">
                                  <Link
                                    to={`/profile/${profileId}`}
                                    className="text-primary text-center"
                                    id="edit"
                                    onMouseUp={() => {
                                      setProfileId(profile.id);
                                      setProfileName(profile.name);
                                    }}
                                    disabled={true}
                                  >
                                    <i
                                      className="mdi mdi-pencil font-size-18 px-2"
                                      id="edittooltip"
                                      onMouseUp={() => {
                                        setProfileId(profile.id);
                                        setProfileName(profile.name);
                                      }}
                                    >
                                      <UncontrolledTooltip
                                        placement="auto"
                                        target="edittooltip"
                                      >
                                        {t("Edit")}
                                      </UncontrolledTooltip>
                                    </i>
                                  </Link>
                                  {/* TODO: add custom styles to css file */}
                                  <span style={{ cursor: "pointer" }}>
                                    <i
                                      className="mdi mdi-window-close text-danger font-size-18 px-2"
                                      id="deletetooltip"
                                      onMouseUp={() => {
                                        setProfileId(profile.id);
                                        setProfileName(profile.name);
                                      }}
                                      onClick={toggleModal}
                                    >
                                      {" "}
                                      <UncontrolledTooltip
                                        placement="auto"
                                        target="deletetooltip"
                                      >
                                        {t("Delete")}
                                      </UncontrolledTooltip>
                                    </i>
                                  </span>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("No matching records found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      <Modal isOpen={modal}>
                        <div className="modal-body">
                          <h5>
                            {t("Do you want delete") + " " + profileName + " ?"}
                          </h5>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            onClick={toggleModal}
                            className="btn btn-danger waves-effect"
                            data-dismiss="modal"
                            style={{ backgroundColor: "#f14646" }}
                          >
                            {t("No")}
                          </button>

                          {loadingDeleteProfile ? (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                            >
                              <Spinner size="sm" animation="border" />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              onClick={() => {
                                handleDelete();
                              }}
                            >
                              {t("Yes")}
                            </button>
                          )}
                        </div>
                      </Modal>
                    </PerfectScrollbar>
                  </div>
                  {renderPagination(
                    page,
                    dataProfile?.paging,
                    handlePreviousPage,
                    handlePage,
                    handleNextPage
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Profiles);
